import { Button, Icon } from '@faxi/web-component-library';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { scrollIntoViewPerClassname } from '../../utils';
import { StyledSignIfCard } from './SignIfCard.styled';

export type SignIfCardProps = {};

const translationKeys = [
  'header-card-item_1',
  'header-card-item_2',
  'header-card-item_3',
];

const SignIfCard: FC<SignIfCardProps> = () => {
  const { t } = useTranslation();

  return (
    <StyledSignIfCard className="cedolauto-sign-if-card">
      <h2 className="cedolauto-sign-if-card__title">
        {t('header-card-title')}
      </h2>

      <ul className="cedolauto-sign-if-card__content">
        {translationKeys.map(translationKey => (
          <li key={translationKey}>
            <Icon name="check" />
            {t(translationKey)}
          </li>
        ))}
      </ul>

      <div className="cedolauto-sign-if-card__actions">
        <Button
          onClick={() => {
            scrollIntoViewPerClassname('cedolauto-application'); //TODO: check do we need this logic on click
          }}
        >
          {t('header-button')}
        </Button>
      </div>
    </StyledSignIfCard>
  );
};

export default SignIfCard;
